import type { ConnectionEndpoint } from "./ConnectionEndpointProvider";

/** Transforms the marked key's outward normal into viewport coordinates, including rotation and reflection. */
export function controlExitDirection(control: Element): ConnectionEndpoint["exitDirection"] {
  const side = Number(control.getAttribute("data-connection-exit-x"));
  if ((side !== -1 && side !== 1) || !(control instanceof SVGGraphicsElement)) return undefined;
  const matrix = control.getScreenCTM();
  if (!matrix) return undefined;
  const determinant = matrix.a * matrix.d - matrix.b * matrix.c;
  if (!Number.isFinite(determinant) || determinant === 0) return undefined;
  // Inverse transpose preserves perpendicularity even with non-uniform scaling or skew.
  const x = side * matrix.d / determinant;
  const y = -side * matrix.c / determinant;
  const length = Math.hypot(x, y);
  if (!Number.isFinite(length) || length === 0) return undefined;
  return { x: x / length, y: y / length };
}
